const FORM_URL = 'https://readdy.ai/api/form/dak4q6jbcsf0ijchd50g';

export interface LeadFormResult {
  ok: boolean;
  message: string;
}

/**
 * Submits the VILLAGARAGE lead form to the built-in Form endpoint.
 * Builds the payload directly from the live form element so browser
 * AutoFill values are captured correctly.
 */
export async function submitLeadForm(form: HTMLFormElement): Promise<LeadFormResult> {
  const data = new FormData(form);

  const honeypot = String(data.get('website_alt') ?? '').trim();
  data.delete('website_alt');

  if (honeypot) {
    // Likely a bot — return a generic success without sending anything.
    return { ok: true, message: '' };
  }

  const params = new URLSearchParams();
  data.forEach((value, key) => {
    if (typeof value === 'string') {
      params.append(key, value);
    }
  });

  let responseText = '';
  try {
    const response = await fetch(FORM_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
    responseText = await response.text();

    let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
    try {
      parsed = JSON.parse(responseText);
    } catch {
      parsed = null;
    }

    const serverMsg =
      parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';

    if (response.ok && parsed?.code === 'OK') {
      return { ok: true, message: '' };
    }

    return { ok: false, message: serverMsg };
  } catch {
    return { ok: false, message: responseText || '' };
  }
}